import { Capacitor } from "@capacitor/core";
import AccountApp from "./AccountApp";
import AccountWeb from "./AccountWeb";

export default function Account() {
    return Capacitor.isNativePlatform() ? <AccountApp /> : <AccountWeb />;
}
